import {Outlet} from "react-router-dom";
import { NavigateLink} from "../../styled";
import {Suspense} from "react";

export const Shared=()=> {

    return (
        <>
            <header>
                <nav>
                    <NavigateLink to='/' end>Home</NavigateLink>
                    <NavigateLink to='/movies'>Movies</NavigateLink>
                </nav>
            </header>
            <Suspense fallback={<div>Loading...</div>}>
                <Outlet/>
            </Suspense>
        </>
    )
}